/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".action-cell[_ngcontent-%COMP%]{justify-content:flex-end}.choose-button[_ngcontent-%COMP%]{margin:0!important}.refresh-button[_ngcontent-%COMP%]{margin-top:40px;margin-bottom:20px}.refresh-button[_ngcontent-%COMP%]   .refresh-icon[_ngcontent-%COMP%]{margin-right:5px}@media (max-width:599px){mat-cell[_ngcontent-%COMP%]{justify-content:center!important}mat-cell[_ngcontent-%COMP%]:last-child{padding-right:0}}"];
export { styles as styles };
